import { render, staticRenderFns } from "./CaptureSignature.vue?vue&type=template&id=7aaa0f8b&"
import script from "./CaptureSignature.vue?vue&type=script&lang=js&"
export * from "./CaptureSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports